import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import './Login.css';
import Navbar from './Navbar';
import Footer from './Footer';
import Loading from './Loading';
import log from './services/logService';

const ACCESS_TOKEN_COOKIE = process.env.REACT_APP_ACCESS_TOKEN_COOKIE;
const REFRESH_TOKEN_COOKIE = process.env.REACT_APP_REFRESH_TOKEN_COOKIE;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); 
  const navigate = useNavigate();

  useEffect(() => {
    const inputs = document.querySelectorAll('.input-container input');
    inputs.forEach(input => {
      const errorMessage = input.parentElement.querySelector('.error-message');
      const label = input.nextElementSibling;

      input.addEventListener('focusout', () => {
        if (!input.value) {
          if (input && label && errorMessage) {
            input.style.borderColor = 'red';
            label.style.color = 'red';
            errorMessage.style.display = 'block';
            label.classList.add('label-error');
          }
        } else {
          if (errorMessage) {
            errorMessage.style.display = 'none';
          }
        }
      });

      input.addEventListener('input', () => {
        if (input.value) {
          if (input && label && errorMessage) {
            input.style.borderColor = '';
            label.style.color = '';
            errorMessage.style.display = 'none';
          }
        } else {
          if (input && label && errorMessage) {
            input.style.borderColor = 'red';
            label.style.color = 'red';
            errorMessage.style.display = 'block';
            label.classList.add('label-error');
          }
        }
      });
    });
  }, []);

  const handleGoogleLogin = () => {
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_GOOGLE_CALLBACK_URI;
    const scope = "openid email profile";
    const responseType = "code";

    const googleAuthUrl = `https://accounts.google.com/o/oauth2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}`;
    window.location.href = googleAuthUrl;
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true); 

    try {
      const response = await fetch(process.env.REACT_APP_EMAIL_LOGIN_URI, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (response.status !== 200) {
        setError("Usuário ou senha inválidos");
        setLoading(false); 
        return;
      }

      const data = await response.json();
      if (data.success) {
        const accessTokenExpiration = new Date(new Date().getTime() + process.env.REACT_APP_JWT_EXPIRATION * 60 * 1000);
        const refreshTokenExpiration = new Date(new Date().getTime() + process.env.REACT_APP_JWT_REFRESH_EXPIRATION * 24 * 60 * 60 * 1000);

        Cookies.set(ACCESS_TOKEN_COOKIE, data.accessToken, { expires: accessTokenExpiration, secure: true, sameSite: 'Strict', path: '/' });
        Cookies.set(REFRESH_TOKEN_COOKIE, data.refreshToken, { expires: refreshTokenExpiration, secure: true, sameSite: 'Strict', path: '/' });
        navigate(data.redirectTo || "/dashboard");
      } else {
        setError(data.message);
      }
    } catch (error) {
      log('Erro ao realizar login:', error);
      setError("Erro ao realizar login. Tente novamente.");
    } finally {
      setLoading(false); 
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <Navbar />
      {loading && <Loading />}
      <div className="login-container">
        <div className="logo-container">
          <img src="./logo.webp" alt="QR Code Brasil" />
        </div>
        <h1><span>Ainda não tem uma conta? </span><a href="/register">Cadastre-se</a></h1>
        <form onSubmit={handleEmailLogin}>
          <div className="input-container">
            <input type="email" id="email" placeholder=" " value={email} onChange={(e) => setEmail(e.target.value)} required />
            <label htmlFor="email">Email</label>
          </div>
          <div className="input-container">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              placeholder=" "
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="password">Senha</label>
            <span className="password-toggle-icon" onClick={toggleShowPassword}>
              {showPassword ? '🙈' : '👁️'}
            </span>
          </div>
          {error && <div className="error-message">{error}</div>}
          <div className="checkbox-container">
            <span className="forgot-password"><a href="/forgot-password">Esqueceu a sua senha?</a></span>
          </div>
          <button type="submit" className="login-button">LOG IN</button>
        </form>
        <div className="separator">
          <hr />
          <span>OU</span>
          <hr />
        </div>
        <div className="google-login">
          <div onClick={handleGoogleLogin}>
            <img src="https://cdn1.iconfinder.com/data/icons/google-s-logo/150/Google_Icons-09-1024.png" alt="Google" />
          </div>
          <button onClick={handleGoogleLogin}>Entrar com uma conta do Google</button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;